export const getPatientDetailsAsync = state => state.patients.patientDetails.async;

export const getPatientDetailsData = state => state.patients.patientDetails.data;
